export default __webpack_public_path__ + "static/media/sidebar-beige@2x.c9391366.png";